import { render, staticRenderFns } from "./ModelosLogsEditar.vue?vue&type=template&id=24fc79aa&scoped=true"
import script from "./ModelosLogsEditar.vue?vue&type=script&lang=js"
export * from "./ModelosLogsEditar.vue?vue&type=script&lang=js"
import style0 from "./ModelosLogsEditar.vue?vue&type=style&index=0&id=24fc79aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc79aa",
  null
  
)

export default component.exports